import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, GraduationCap } from "lucide-react";
import api from "@/lib/api";
import { AboutMission, DirectorProfile, AboutValues, AboutHistory } from "@/components/about/AboutSections";

const DEFAULT_MISSION =
  "Our mission is to get more people to fall in love with the game of squash. While we've built a legacy of creating junior champions and helping them get into the best colleges worldwide, we now focus on growing the squash community and sharing the joy of this incredible sport with players of all ages and backgrounds.";

const About = () => {
  const [director, setDirector] = useState(null);

  useEffect(() => {
    api.getDirector().then((res) => setDirector(res.data)).catch(() => setDirector(null));
  }, []);

  return (
    <div className="pt-16" data-testid="about-page" style={{ background: "var(--lrg-bg)" }}>
      <section className="py-16" style={{ background: "var(--lrg-surface)" }} data-testid="about-hero">
        <div className="container-custom">
          <div className="overline mb-4">Since 2002</div>
          <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tighter text-[#F2EDE4] mb-3">About LRG Squash</h1>
          <p className="text-[#F2EDE4]/30 max-w-lg">Developing squash athletes in Baltimore and Princeton since 2002. From creating national champions to welcoming new players.</p>
        </div>
      </section>

      <AboutMission mission={director?.mission || DEFAULT_MISSION} />
      {director && <DirectorProfile director={director} />}
      <AboutValues />
      <AboutHistory />

      <section className="section" style={{ background: "var(--lrg-surface)" }} data-testid="about-college">
        <div className="container-custom max-w-3xl text-center">
          <GraduationCap className="w-8 h-8 text-[#0D6B56] mx-auto mb-4" />
          <h2 className="font-display text-3xl md:text-4xl font-bold text-[#F2EDE4] mb-4">Your Path to College Squash</h2>
          <p className="text-[#F2EDE4]/40 mb-8">
            Placements at Harvard, Yale, Princeton, Stanford, Williams, Brown, Columbia, Cornell, Middlebury, Amherst, Georgetown, and more.
          </p>
          <Link to="/college-consulting" className="btn-primary inline-flex items-center gap-2" data-testid="about-college-cta">
            College Consulting <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default About;
